import { ENUM_GET_ACTIONS_REQUEST } from "UserAuthorized/actionTypes";

export const enumGetActions = () => {
  return { type: ENUM_GET_ACTIONS_REQUEST };
};
